import React from 'react'
import classNames from 'classnames'

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'

import Grid, { GridProps } from '@material-ui/core/Grid'

interface Props extends GridProps {

}

const styles = createStyles({
  root: {
    height: 29,
    backgroundColor: '#FFFFFF',
    borderBottomLeftRadius: 2,
    borderBottomRightRadius: 2,
    paddingLeft: 8,
    paddingRight: 8,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const GameCardBottomInfoBar: React.SFC<InjectedProps> = ({
  classes,
  children,
  className,
  ...props
}) => {
  return (
    <Grid
      className={classNames(className, classes.root)}
      alignItems="center"
      justify="center"
      wrap="nowrap"
      container
      {...props}
    >
      <Grid zeroMinWidth xs item>
        {children}
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(GameCardBottomInfoBar)
